import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { path: '/admin', label: 'Dashboard', end: true },
  { path: '/admin/locations', label: 'Locations' },
  { path: '/admin/users', label: 'Users' },
  { path: '/admin/services', label: 'Master Services' },
  { path: '/admin/payments', label: 'Payment Config' },
  { path: '/admin/analytics', label: 'Analytics' },
  { path: '/admin/waivers', label: 'Consent Forms' },
  { path: '/admin/email-profiles', label: 'Email Profiles' },
  { path: '/admin/settings', label: 'Settings' },
  { path: '/admin/coupons', label: 'Coupons' },
  { path: '/admin/campaigns', label: 'Campaigns' },
];

export default function SuperAdminLayout() {
  const { user, logout, isManager, isStaff, canClient } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();
  const doLogout = () => { logout(); navigate('/login'); };
  const initials = (user?.firstName?.[0] || '') + (user?.lastName?.[0] || '');
  const isActive = (path, end) => end ? loc.pathname === path : loc.pathname.startsWith(path);

  return (
    <>
      <div className="mobile-header" style={{ background: 'linear-gradient(90deg, #0D0D1A, #1A1A2E)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="hamburger" onClick={() => setOpen(!open)} style={{ color: '#fff' }}><span /><span /><span /></div>
          <span style={{ fontFamily: 'var(--rr-font-heading)', fontSize: 17, color: '#C9A84C' }}>Super Admin</span>
        </div>
        <span className="rr-badge-orange" style={{ fontSize: 9, padding: '4px 10px', borderRadius: 6, background: 'rgba(255,107,53,.14)', border: '1px solid rgba(255,107,53,.34)', color: '#FF8C5F', fontWeight: 800, letterSpacing: '.14em' }}>LIVE</span>
      </div>
      <div className={`sidebar-overlay ${open ? 'open' : ''}`} onClick={() => setOpen(false)} />
      <div className="app-container">
        <aside className={`app-sidebar ${open ? 'open' : ''}`} style={{ background: 'linear-gradient(180deg, #0D0D1A 0%, #1A1A2E 100%)', padding: '26px 18px 20px' }}>
          <div style={{ padding: '0 6px 22px', borderBottom: '1px solid rgba(255,255,255,.07)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
              <div style={{ width: 36, height: 36, borderRadius: 9, background: 'linear-gradient(140deg, #C9A84C, #8A6E22)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--rr-font-heading)', fontSize: 17, fontWeight: 700, color: '#12121C' }}>R</div>
              <div>
                <div style={{ fontFamily: 'var(--rr-font-heading)', fontSize: 15.5, fontWeight: 600, color: '#F6F4EE', lineHeight: 1.1 }}>Royal Revitalization</div>
                <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: '.14em', color: 'rgba(246,244,238,.42)' }}>Franchise Network</div>
              </div>
            </div>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 7, marginTop: 14, padding: '5px 10px', borderRadius: 6, background: 'rgba(255,107,53,.14)', border: '1px solid rgba(255,107,53,.34)' }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#FF6B35' }} />
              <span style={{ fontSize: 9.5, fontWeight: 800, letterSpacing: '.16em', color: '#FF8C5F' }}>SUPER ADMIN</span>
            </div>
          </div>

          <nav style={{ display: 'flex', flexDirection: 'column', gap: 3, padding: '18px 0 0', flex: 1 }}>
            <div style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '.16em', color: 'rgba(246,244,238,.28)', padding: '0 8px 10px' }}>NETWORK</div>
            {navItems.map(item => {
              const active = isActive(item.path, item.end);
              return (
                <NavLink key={item.path} to={item.path} end={item.end} onClick={() => setOpen(false)}
                  style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '10px 12px', borderRadius: 9, color: active ? '#C9A84C' : 'rgba(246,244,238,.55)', background: active ? 'rgba(201,168,76,.1)' : 'transparent', textDecoration: 'none', fontSize: 13, fontWeight: 600, boxShadow: active ? 'inset 3px 0 0 #C9A84C' : 'none' }}>
                  <span style={{ width: 7, height: 7, borderRadius: 2, background: active ? '#C9A84C' : 'rgba(246,244,238,.25)', transform: 'rotate(45deg)' }} />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>

          <div style={{ padding: '14px 6px', borderTop: '1px solid rgba(255,255,255,.07)' }}>
            <div style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '.14em', color: 'rgba(246,244,238,.25)', marginBottom: 8 }}>SWITCH PORTAL</div>
            {isManager && <NavLink to="/manager" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Manager Portal <span style={{ opacity:.5 }}>→</span></NavLink>}
            {isStaff &&  <NavLink to="/staff" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Staff Portal <span style={{ opacity:.5 }}>→</span></NavLink>}
            {canClient &&  <NavLink to="/" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Client Portal <span style={{ opacity:.5 }}>→</span></NavLink>}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 8px', borderTop: '1px solid rgba(255,255,255,.07)' }}>
            <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'rgba(255,107,53,.16)', border: '1px solid rgba(255,107,53,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11.5, fontWeight: 700, color: '#FF8C5F' }}>{initials}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#F6F4EE' }}>{user?.firstName} {user?.lastName}</div>
              <div style={{ fontSize: 10.5, color: 'rgba(246,244,238,.4)' }}>Super Admin</div>
            </div>
            <button onClick={doLogout} style={{ background: 'none', border: 'none', color: 'rgba(246,244,238,.35)', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>Sign Out</button>
          </div>
        </aside>
        <main className="app-main" style={{ animation: 'rrFade .28s ease both' }}><Outlet /></main>
      </div>
    </>
  );
}
